<script setup lang="ts">
import { HOTEL_ONLY, AIR_ONLY } from '@/constants';
import CruiseInfoBooking from '@/components/modal/priceBooking/CruiseInfoBooking.vue';
import FlightInfoBooking from '@/components/modal/priceBooking/FlightInfoBooking.vue';
import HotelInfoBooking from '@/components/modal/priceBooking/HotelInfoBooking.vue';
import PriceBookingTable from '@/components/modal/priceBooking/PriceBookingTable.vue';

interface Props {
  cruiseData?: any;
  quoteType?: string;
}

defineProps<Props>();

const totalSeatBookingFlight = (flights: any) => {
  const economy = flights?.find((flight: any) => flight.class === 'Economy');
  const business = flights?.find((flight: any) => flight.class === 'Business');
  return economy.totalSeats + business.totalSeats;
};
</script>
<template>
  <div>
    <div class="flight-info" v-if="cruiseData.flightInfo">
      <div class="mb-2">
        <div v-if="totalSeatBookingFlight(cruiseData.flightInfo?.infoPriceBreakdownCommon?.infoClasses)">
          <FlightInfoBooking :infoData="cruiseData.flightInfo?.infoPriceBreakdownCommon" />
          <div class="flight-pricing">
            <div v-for="(air, indexAirDetail) in cruiseData.flightInfo?.flightPrice" :key="indexAirDetail">
              <PriceBookingTable :quoteType="AIR_ONLY" :dataPricing="air" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cabin-info">
      <div class="mb-2" v-if="cruiseData.cruiseInfoHeader.adults">
        <CruiseInfoBooking :infoData="cruiseData.cruiseInfoHeader" />
        <div class="cabin-pricing">
          <div v-for="(cabin, indexCabin) in cruiseData.cruiseCabinPricing" :key="indexCabin">
            <PriceBookingTable isOnlySellingPrice :quoteType="quoteType" :dataPricing="cabin" />
          </div>
        </div>
      </div>
    </div>
    <div class="pre-hotel-info">
      <div class="mb-5" v-for="(hotel, indexHotel) in cruiseData.cruisePreHotelPricing" :key="indexHotel">
        <div v-if="hotel?.cruisePrePostHotelInfo?.numOfRooms">
          <HotelInfoBooking :hotelTitle="$t('create_quote.pre_hotel')" :priceData="hotel.prePostHotelPricing" :infoData="hotel?.cruisePrePostHotelInfo" :quoteType="quoteType" :option="indexHotel" />
          <div class="room-pricing">
            <div v-for="(room, indexRoom) in hotel.prePostHotelPricing" :key="indexRoom">
              <PriceBookingTable isOnlySellingPrice :quoteType="HOTEL_ONLY" :dataPricing="room" :isHotelCruise="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="post-hotel-info">
      <div class="mb-5" v-for="(hotel, indexHotel) in cruiseData.cruisePostHotelPricing" :key="indexHotel">
        <div v-if="hotel?.cruisePrePostHotelInfo?.numOfRooms">
          <HotelInfoBooking :hotelTitle="$t('create_quote.post_hotel')" :priceData="hotel.prePostHotelPricing" :infoData="hotel?.cruisePrePostHotelInfo" :quoteType="quoteType" :option="indexHotel" />
          <div class="room-pricing">
            <div v-for="(room, indexRoom) in hotel.prePostHotelPricing" :key="indexRoom">
              <PriceBookingTable isOnlySellingPrice :quoteType="HOTEL_ONLY" :dataPricing="room" :isHotelCruise="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
